/** Created as per:
1. https://schema.org/
2. https://support.google.com/webmasters/thread/5820005?hl=en
3. https://developers.google.com/search/docs/data-types/carousel?hl=de
4. https://jsonld-examples.com/schema.org/code/blog-markup.php
*/

export const DEFAULT_PRODUCT = () => {
  // const _defaultProdItem = DEFAULT_PRODUCT_ITEM()
  return {
    '@context': 'http://schema.org',
    // ..._defaultProdItem,
    ...DEFAULT_PRODUCT_ITEM()
  }
}

export const DEFAULT_BLOG_POSTING = () => {
  return {
    '@type': 'blogPosting',
    mainEntityOfPage: 'https://example.com/posts/blog-one.html',
    headline: 'Some headline',
    author: 'Author Name',
    datePublished: '10 May, 2016',
    dateModified: '10 May, 2016',
    image: {
      '@type': 'imageObject',
      url: 'https://example.com/image/post-one-thumbnail.jpg',
      height: '200',
      width: '400'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Blog Orga name',
      logo: {
        '@type': 'imageObject',
        url: 'https://example.com/logo.png'
      }
    }
  }
}

export const DEFAULT_BLOG = () => {
  return {
    '@context': 'http://schema.org',
    '@type': 'Blog',
    name: 'Blog name',
    url: 'https://example.com',
    description: 'Same as meta description',
    publisher: {
      '@type': 'Organization',
      name: 'Blog Orga Name'
    },
    blogPosts: []
  }
}

export const DEFAULT_ITEM_LIST = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: []
  }
}

export const DEFAULT_LIST_ITEM = () => {
  return {
    '@type': 'ListItem',
    position: '0',
    item: {}
  }
}

export const DEFAULT_PRODUCT_ITEM = () => {
  return {
    '@type': 'Product',
    '@id': '',
    name: '',
    image: '',
    description: '',
    offers: {}
  }
}

export const DEFAULT_OFFERS_ITEM = () => {
  return {
    '@type': 'Offer',
    availability: '',
    price: '',
    priceCurrency: ''
  }
}

export const ITEM_AVAILABILITY_IN_STOCK = 'https://schema.org/InStock'
export const ITEM_AVAILABILITY_SOLD_OUT = 'https://schema.org/SoldOut'
